import {createReducer} from '../utility'




export const userApplications = createReducer({},{
    "USER_APPLICATIONS_RECEIVED"(state, {data}){
        if(data){
            return {
                ...state,
                applications: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})